import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>By applying the tips and skills in this section you can
                                                    optimise your effort to ensure that
                                                    you concentrate as much of your time and energy as possible
                                                    on the most important and
                                                    relevant tasks. This ensures that you achieve the greatest
                                                    benefit possible with the limited
                                                    amount of time available to you.</p>
                                            </div>
                                            <br/>
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>KNOWING HOW TO TAKE RESPONSIBILITY
                                            </div>

                                            <div className="border_subtitle">Step 1 – What is your
                                                objective?
                                            </div>
                                            <p>Make sure you know where your responsibility starts and ends
                                                and exactly what you’ve been
                                                asked to achieve.</p>
                                            <div className="border_subtitle">Step 2 – What needs to be
                                                done?
                                            </div>
                                            <p>And by when? Once you’re clear about this you can ‘map’
                                                separate stages against a timescale, so
                                                you can monitor progress or delays. Reaching each stage will
                                                also give you a sense of achievement
                                                along the way.</p>
                                            <div className="border_subtitle">Step 3 – Who needs to be
                                                involved?
                                            </div>
                                            <p>Even if a team has already been chosen for the task or
                                                project, check that each member is
                                                assigned a role in which they feel confident.</p>
                                            <div className="border_subtitle">Step 4 – Ensure others know you
                                                are leading
                                            </div>
                                            <p>Make yourself a part of the team and easily available to give
                                                and receive feedback. It’s a mistake
                                                to think you can lead effectively by marching ahead and
                                                shouting over your shoulder.</p>
                                            <div className="border_subtitle">Step 5 – Get stuck in!</div>
                                            <p>Look for some ‘quick wins’ to develop confidence and gain
                                                momentum – it’ll help confirm your
                                                leadership to yourself as well as others!</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <div className="paraspace"><p>Having read the tool the next step
                                                is to act in order to take responsibility. All the research
                                                suggests that planning how you will achieve your goal makes
                                                it much more likely that you will do
                                                so in reality:</p></div>
                                            <ul className="greenbullet-list zeroPaddingUl5">
                                                <li>Consider what you’ve read here, and what is most
                                                    relevant to you
                                                </li>
                                                <li>Identify how you can apply it to a specific situation
                                                </li>
                                                <li>Think, not only about what you could do but what may
                                                    deter you
                                                </li>
                                                <li><p>Think of solutions for these potential problems in
                                                    advance, so you can deal with them or
                                                    produce alternatives, if necessary.</p></li>

                                                <div className="circle_title sept"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>FINALLY...
                                                </div>
                                                <p>Finally, enlist the support of others. Knowing you have
                                                    access to advice will increase your personal
                                                    and professional effectiveness.</p>

                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page5')}
                                                        className="button-next-previous-done task">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div onClick={this.props.handleChangePage('Page7')}
                                                         className="button-next-previous-done task">Next &gt;&gt;</div>
                                                </div>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}